import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, FileDown, BookOpen } from "lucide-react";
import api, { downloadDoc, apiErr } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { AdminHeading } from "@/components/admin/ui";

export default function AdminQR() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/qr").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const download = (png, kind) => { const a = document.createElement("a"); a.href = png; a.download = `the-d-${kind}.png`; a.click(); };
  const dl = async (path, name) => { try { await downloadDoc(path, name); } catch (e) { toast.error(apiErr(e)); } };
  return (
    <div>
      <AdminHeading title="QR Codes" subtitle="Branded QR codes for the property. Download and print. No private credentials are embedded.">
        <div className="flex gap-2">
          <button onClick={() => dl("/admin/documents/qr-sheet", "the-d-qr-codes.pdf")} className="btn-gold px-4 py-2 text-sm flex items-center gap-2" data-testid="qr-sheet-pdf"><FileDown size={15} /> QR Sheet PDF</button>
          <button onClick={() => dl("/admin/documents/house-guide", "the-d-house-guide.pdf")} className="btn-ghost-gold px-4 py-2 text-sm flex items-center gap-2" data-testid="house-guide-pdf"><BookOpen size={15} /> House Guide PDF</button>
        </div>
      </AdminHeading>
      {items === null ? <Loading /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((q) => (
            <div key={q.kind} className="bg-surface/60 border border-white/10 rounded-lg p-4 text-center">
              <img src={q.png} alt={q.kind} className="h-32 w-32 mx-auto rounded" />
              <p className="text-xs tracking-label uppercase text-muted-foreground mt-3 capitalize">{q.kind.replace("-", " ")}</p>
              <button onClick={() => download(q.png, q.kind)} className="btn-ghost-gold px-3 py-1.5 text-xs mt-2 flex items-center gap-1 mx-auto" data-testid={`qr-download-${q.kind}`}><Download size={12} /> PNG</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
